var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.responsive == 'PC')?_c('pc-manage-pool'):_vm._e(),(_vm.responsive != 'PC')?_c('mobile-manage-pool'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }